import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\AddDocumentByDossierIdToEnveloppeController::__invoke
* @see app/Http/Controllers/Dossier/AddDocumentByDossierIdToEnveloppeController.php
* @route '/api/dossier/{dossier}/{type}/{document_id}/add-to-enveloppe'
*/
const AddDocumentByDossierIdToEnveloppeController = (args: { dossier: string | number | { id: string | number }, type: string | number, document_id: string | number } | [dossier: string | number | { id: string | number }, type: string | number, document_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddDocumentByDossierIdToEnveloppeController.url(args, options),
    method: 'post',
})

AddDocumentByDossierIdToEnveloppeController.definition = {
    methods: ["post"],
    url: '/api/dossier/{dossier}/{type}/{document_id}/add-to-enveloppe',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\AddDocumentByDossierIdToEnveloppeController::__invoke
* @see app/Http/Controllers/Dossier/AddDocumentByDossierIdToEnveloppeController.php
* @route '/api/dossier/{dossier}/{type}/{document_id}/add-to-enveloppe'
*/
AddDocumentByDossierIdToEnveloppeController.url = (args: { dossier: string | number | { id: string | number }, type: string | number, document_id: string | number } | [dossier: string | number | { id: string | number }, type: string | number, document_id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            type: args[1],
            document_id: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        type: args.type,
        document_id: args.document_id,
    }

    return AddDocumentByDossierIdToEnveloppeController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{type}', parsedArgs.type.toString())
            .replace('{document_id}', parsedArgs.document_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\AddDocumentByDossierIdToEnveloppeController::__invoke
* @see app/Http/Controllers/Dossier/AddDocumentByDossierIdToEnveloppeController.php
* @route '/api/dossier/{dossier}/{type}/{document_id}/add-to-enveloppe'
*/
AddDocumentByDossierIdToEnveloppeController.post = (args: { dossier: string | number | { id: string | number }, type: string | number, document_id: string | number } | [dossier: string | number | { id: string | number }, type: string | number, document_id: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddDocumentByDossierIdToEnveloppeController.url(args, options),
    method: 'post',
})

export default AddDocumentByDossierIdToEnveloppeController